import type {Alpine as AlpineType} from 'alpinejs';

import {registerLayoutDirective} from './directives/layout';
import {registerRequestDirective} from './directives/request';
import {registerTransitionDirective} from './directives/transition';
import morph from './runtime/morph-engine';
import {setPropReactivity} from './runtime/codecs';
import {registerConfirm} from './runtime/confirm';
import {registerStream} from './runtime/engine/stream';
import {registerThemeStore} from './runtime/theme';
import {registerUiMagic, ui} from './runtime/ui';

type CoreRuntimePlugin = (AlpineInstance: AlpineType) => void;
const registered = new WeakSet<AlpineType>();

const coreRuntime: CoreRuntimePlugin = (AlpineInstance): void => {
    if (registered.has(AlpineInstance)) return;
    registered.add(AlpineInstance);
    setPropReactivity(AlpineInstance.reactive);
    AlpineInstance.plugin(morph);
    registerLayoutDirective(AlpineInstance);
    registerUiMagic(AlpineInstance);
    registerTransitionDirective(AlpineInstance);
    registerThemeStore(AlpineInstance);
    registerConfirm();
    registerRequestDirective(AlpineInstance);
    registerStream(AlpineInstance);
};

export {coreRuntime, ui};
export default coreRuntime;
export type {CoreRuntimePlugin};
export {
    bool,
    createAlpineMachine,
    createMachine,
    decodeProps,
    defineAlpineData,
    defineManifest,
    defineProps,
    defineStyles,
    json,
    mergeBindings,
    number,
    oneOf,
    propsFromSchema,
    resolveStyle,
    string,
    createTransitionCoordinator,
    defineHook,
} from './runtime';
export type {
    AlpineMachine,
    AlpineMachineOwner,
    AlpinePropsChangedEvent,
    AlpineDataFactory,
    AlpineDataRegistrar,
    CodecFn,
    ComponentManifest,
    CreateAlpineMachineOptions,
    DecodePropsOptions,
    Machine,
    MachineConfig,
    MachineEffect,
    MachineEffectList,
    MachineEffectRef,
    MachineEntry,
    MachineEvent,
    MachineEventObject,
    MachineGuard,
    MachineOptions,
    MachineReducer,
    MachineReducerList,
    MachineReducerRef,
    MachineScope,
    MachineSnapshot,
    MachineStateConfig,
    MachineStateValue,
    MachineTransition,
    MachineTransitionDefinition,
    MachineUpdate,
    DefineManifestOptions,
    DefineStylesOptions,
    ManifestPart,
    ManifestProp,
    ManifestPropDetails,
    ManifestToken,
    MachineFactoryScope,
    BindingInput,
    PropState,
    PropsFromSchemaOptions,
    MergeBindingsOptions,
    ResolveStyleOptions,
    SchemaPropDetails,
    SchemaToProps,
    StyleDefinition,
    StylePart,
    StyleProps,
    TrellisAlpineComponent,
    AnyTransitionHook,
    TransitionCallback,
    TransitionContext,
    TransitionCoordinator,
    TransitionCoordinatorOptions,
    TransitionEventCreator,
    TransitionForHook,
    TransitionHookDefinition,
    UiGetOptions,
    UiRequestOptions,
    UiRuntime,
} from './runtime';
export {registerTransitionDirective} from './directives/transition';
